module.exports = __webpack_public_path__ + "static/workplace-giving--sm-fd9646c838ef84ce3a505f09ac73c4b8.jpg";